import { render, staticRenderFns } from "./FeePrivacy.vue?vue&type=template&id=77d1d1d2"
import script from "./FeePrivacy.vue?vue&type=script&lang=js"
export * from "./FeePrivacy.vue?vue&type=script&lang=js"
import style0 from "./FeePrivacy.vue?vue&type=style&index=0&id=77d1d1d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports